import draggable from 'vuedraggable'
import MapBuilder from '../services/MapBuilder'
import MapBox from '../services/MapBox'

export default {
  name: 'MyMap',
  props: {
    siteName: String
  },
  components: {
    draggable
  },
  data() {
    return {
      breadcrumbs:[],
      mapData: null,
      map: null,
      roadHoverId: null
    }
  },
  created() {
  },
  async mounted () {
    // load mapbox
    await this.$loadScript('https://api.mapbox.com/mapbox-gl-js/v1.0.0/mapbox-gl.js');
    await this.$loadScript('https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-draw/v1.0.9/mapbox-gl-draw.js');

    this.init();

    this.breadcrumbs = [
      {
        text: this.siteName,
        disabled: false,
        href: '/'
      },
      {
        text: 'My Map',
        disabled: true
      }
    ];
  },
  methods: {
    init() {
      let mapData = MapBuilder.getMapData();

      if (mapData.roadList.length > 0) {
        this.mapData = mapData;
        window.requestAnimationFrame(this.buildMap);
      }  else {
        this.mapData = false;
      }
    },

    saveMyMap() {
      MapBuilder.saveMapData(this.mapData);
    },
   
    clearMyMap() {
      // TODO: add confirmation
      MapBuilder.clearMapData();
      this.mapData = null;
    },

    removeRoad(road) {
      // TODO: add confirmation
      // TODO: remove road from map, and any connected routes
      this.mapData.roadList = MapBuilder.removeRoad(road).roadList;
      this.removeRoadFromMap(road);

      if (this.mapData.roadList.length == 0) {
        this.mapData = null;
      }
    },
    
    buildMap() {
      this.map = MapBox.createMap();
      let mapBounds = MapBox.getMapBoundsFromMany(this.mapData.roadList);
      
      // this.addDrawTools(map);
      
      this.map.on('load', () => {
        this.map.fitBounds(mapBounds, { padding: { top: 20, left: 350, bottom: 20, right: 20 }, duration: 0 });
        this.mapData.roadList.forEach(road => this.addRoadToMap(road));
      });
    },

    async createRoute() {
      let routedRoads = await MapBuilder.createRoutesBetweenRoads(this.mapData.roadList);
      
      for(let road of routedRoads) {
        if (MapBuilder.isRoadConnector(road)) {
          this.addRoadToMap(road, true);
        }
      }
      
      this.mapData.roadList = routedRoads;
      this.map.fitBounds(MapBox.getMapBoundsFromMany(this.mapData.roadList), { padding: { top: 20, left: 350, bottom: 20, right: 20 }});
    },
    
    addRoadToMap(road) {
      let root = this;

      this.map.addSource(`${road.name}Source`, {
        'type': 'geojson',
        'data': road
      });
      
      this.map.addLayer({
        'id': road.name,
        'type': 'line',
        'source': `${road.name}Source`,
        'paint': {
          'line-color': MapBuilder.isRoadConnector(road) ? MapBox.settings.connectorLinColor : MapBox.settings.lineColor,
          'line-width': 4,
          'line-opacity': 0.7
        }
      });

      this.map.on('mouseleave', road.name, function(e) {
        setTimeout(() => root.roadHoverId = null, 500);
      });
      
      this.map.on('mouseenter', road.name, function(e) {
        root.roadHoverId = road.name;
      });
    },

    removeRoadFromMap(road) {
      this.map.off('mouseenter', road.name);
      this.map.off('mouseleave', road.name);
      this.map.removeLayer(road.name);
      this.map.removeSource(`${road.name}Source`);
    },

    mapHighlight(road, highlight) {      
      MapBox.highlightRoad(this.map, road, highlight);
    },

    addDrawTools() {
      var draw = new window.MapboxDraw({
        // Instead of showing all the draw tools, show only the line string and delete tools
        displayControlsDefault: false,
        controls: {
          line_string: true,
          trash: true
        },
        styles: [
          // Set the line style for the user-input coordinates
          {
            'id': 'gl-draw-line',
            'type': 'line',
            'filter': ['all', ['==', '$type', 'LineString'],
              ['!=', 'mode', 'static']
            ],
            'layout': {
              'line-cap': 'round',
              'line-join': 'round'
            },
            'paint': {
              'line-color': '#438EE4',
              'line-dasharray': [0.2, 2],
              'line-width': 4,
              'line-opacity': 0.7
            }
          },
          // Style the vertex point halos
          {
            'id': 'gl-draw-polygon-and-line-vertex-halo-active',
            'type': 'circle',
            'filter': ['all', ['==', 'meta', 'vertex'],
              ['==', '$type', 'Point'],
              ['!=', 'mode', 'static']
            ],
            'paint': {
              'circle-radius': 12,
              'circle-color': '#FFF'
            }
          },
          // Style the vertex points
          {
            'id': 'gl-draw-polygon-and-line-vertex-active',
            'type': 'circle',
            'filter': ['all', ['==', 'meta', 'vertex'],
              ['==', '$type', 'Point'],
              ['!=', 'mode', 'static']
            ],
            'paint': {
              'circle-radius': 8,
              'circle-color': '#438EE4',
            }
          },
        ]
      });
      
      // Add the draw tool to the map
      this.map.addControl(draw);
    }
  }
}